
define('text!app/../../views/default.html',[],function () { return '<div class="default">\n  <div class="page-content">\n  \tComing Soon\n  </div>\n</div>\n';});

